export const WIZ_LIVE = 5;
export const QUIZ_COUNT = 10;
